module.exports = __webpack_public_path__ + "svg/ep-guide-img.ec36939.svg";